var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bradgall pr-8"},[_c('div',{staticClass:"flex gap-6"},[_c('div',{staticClass:"w-5/12"},[_c('CampaignStatus')],1),_c('div',{staticClass:"w-4/12"},[_c('RecommendedUpgrade')],1),_c('div',{staticClass:"w-3/12"},[_c('MyResources')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }